import { FC, SVGProps } from 'react';

export const SpFace1Icon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width='32' height='57' viewBox='0 0 32 57' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
		<path
			d='M8.85454 21.127C3.42627 10.6386 18.4371 2.12705 24.8625 12.0663C27.4658 16.1299 34.002 12.3409 31.3986 8.27732C26.4689 0.699307 16.6646 -2.48565 8.4668 2.18196C0.268992 6.84958 -1.83584 16.8437 2.31847 24.916C4.5341 29.1992 11.0702 25.4102 8.85454 21.127Z'
			fill='currentColor'
		/>
		<path
			d='M23.1453 35.8731C28.5736 46.3615 13.5627 54.873 7.13738 44.9337C4.534 40.8702 -2.0021 44.6592 0.601267 48.7227C5.53104 56.3007 15.3352 59.4856 23.533 54.8181C31.7309 50.1505 33.8357 40.1563 29.6814 32.0841C27.4658 27.8009 20.9297 31.5899 23.1453 35.8731Z'
			fill='currentColor'
		/>
		<path
			d='M10.8484 37.4906C12.9286 37.4906 14.6149 35.8188 14.6149 33.7565C14.6149 31.6943 12.9286 30.0225 10.8484 30.0225C8.7681 30.0225 7.08179 31.6943 7.08179 33.7565C7.08179 35.8188 8.7681 37.4906 10.8484 37.4906Z'
			fill='currentColor'
		/>
		<path
			d='M20.2097 26.1791C22.2899 26.1791 23.9763 24.5073 23.9763 22.445C23.9763 20.3828 22.2899 18.7109 20.2097 18.7109C18.1295 18.7109 16.4431 20.3828 16.4431 22.445C16.4431 24.5073 18.1295 26.1791 20.2097 26.1791Z'
			fill='currentColor'
		/>
	</svg>
);
